<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[employeeSelectItems$, payrollItems$, EmployeeDS.entities$]"
></ef-loading-container>
<div>          
    <p-message
        severity="info"
        [escape]="false"
        [text]="payrollHelpHtml">
    </p-message>
</div>
<div class="payroll-workspace-tabs">
    <p-tabs value="0">
        <p-tablist>
            <p-tab value="0">Employee Pay Rate</p-tab>
            <p-tab value="1">Employee Payroll Items</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <ef-employee-base-rate-presenter
                    [rows]="baseRateRows$ | async"
                    (Save)="onSaveBaseRate($event)"
                ></ef-employee-base-rate-presenter>
            </p-tabpanel>
            <p-tabpanel value="1">
                <div class="mt-1 mb-1">
                    <ef-employee-payroll-item-filter
                        [payrollItemTypes]="payrollItemTypeSelectItems$ | async"
                        [payrollItems]="payrollItemsSelectItems$ | async"
                        [employees]="employeeSelectItems$ | async"
                        [userTypes]="EmployeeDS.entities$ | async"
                        (FillGrid)="FillGridSubject.next($event)"
                        (FilterPayrollItemType)="onFilterPayrollItemType($event)"
                    ></ef-employee-payroll-item-filter>
                </div>
                <ef-employee-payroll-item-presenter
                    [items]="sortedEmployeePayrollItems$ | async"
                    [employeeSelectItems]="employeeSelectItems$ | async"
                    [employees]="EmployeeDS.entities$ | async"
                    [payrollItems]="payrollItemsSelectItems$ | async"
                    (EditItem)="onEditItem($event)"
                    (Save)="onSave($event)"
                    (ShowSaveSubject)="onShowSave($event)"
                    (SaveItem)="SaveItemSubject.next($event)"
                    (DeleteItem)="onDeleteItem($event)"
                ></ef-employee-payroll-item-presenter>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>
